import { SimpleGet } from '../services/routes';

export const fetchAllNotifications = (url='/notifications') => SimpleGet({}, url);
export const fetchUnreadCount = (url='/notifications/unreadCount') => SimpleGet({}, url);